'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'rainbow';
var width = 640;
var height = 512;
var aliases = [127752];
var unicode = 'f75b';
var svgPathData = ['M24 480c13.3 0 24-10.7 24-24l0-96C48 209.8 169.8 88 320 88s272 121.8 272 272l0 96c0 13.3 10.7 24 24 24l-112 0c13.3 0 24-10.7 24-24l0-96c0-114.9-93.1-208-208-208s-208 93.1-208 208l0 96c0 13.3 10.7 24 24 24L24 480zm112 0c13.3 0 24-10.7 24-24l0-96c0-88.4 71.6-160 160-160s160 71.6 160 160l0 96c0 13.3 10.7 24 24 24l-112 0c13.3 0 24-10.7 24-24l0-96c0-53-43-96-96-96s-96 43-96 96l0 96c0 13.3 10.7 24 24 24l-112 0z', 'M320 88C169.8 88 48 209.8 48 360l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96C0 183.3 143.3 40 320 40s320 143.3 320 320l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96C592 209.8 470.2 88 320 88zm0 224c-26.5 0-48 21.5-48 48l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-53 43-96 96-96s96 43 96 96l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-26.5-21.5-48-48-48zM160 360l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-114.9 93.1-208 208-208s208 93.1 208 208l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-88.4-71.6-160-160-160s-160 71.6-160 160z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;